import React from 'react';
import styled from 'styled-components';
import {
  ICohortRow,
  IRowMeta,
} from '../../../../../../redux/slices/oldBuilder';
import { HighlightedEntity } from '../../../../../HighlightingContext';
import { useAppSelector } from '../../../../../../redux/hooks';
import MeasureRowContent from '../../../../Measures/MeasureRowContent';
import MeasureCohortMeasureHeader from './MeasureCohortMeasureHeader';
import { borderedContent } from '../../../../../../styles/shareableStyles';

interface IProps {
  rowMeta: IRowMeta;
  cohortRow: ICohortRow;
}

const Container = styled(HighlightedEntity)`
  ${borderedContent};
`;

const MeasureCohort = ({ rowMeta, cohortRow }: IProps) => {
  const { isCollapsedMeasure } = cohortRow;

  const measureFunctions = useAppSelector(
    ({ builder }) => builder.cohortConfig.measureConfig.functions,
  );

  return (
    <Container>
      <MeasureCohortMeasureHeader rowMeta={rowMeta} />
      {!isCollapsedMeasure && (
        <MeasureRowContent
          rowMeta={rowMeta}
          measureFunctions={measureFunctions}
        />
      )}
    </Container>
  );
};

export default MeasureCohort;
